import React__default from 'react';
import numeral from 'numeral';

function formatMonetaryAmountAsJsx(amount, options) {
  if (options === void 0) {
    options = {
      sup: false,
      round: false
    };
  }

  var amountNumeral = numeral(amount.amount);
  var roundingFn;

  switch (options.round) {
    case 'ceil':
      roundingFn = Math.ceil;
      break;

    case 'floor':
      roundingFn = Math.ceil;
      break;

    case true:
      roundingFn = Math.round;
      break;
  }

  if (options.sup) {
    return React__default.createElement(React__default.Fragment, null, amountNumeral.format('$0,0', roundingFn), React__default.createElement("sup", {
      className: options.supClassName
    }, amountNumeral.format('.00', roundingFn)));
  } else {
    // Assumes that when rounding without <sup> tags, we don't want to display cents/decimals
    return amountNumeral.format(roundingFn ? '$0,0' : '$0,0.00', roundingFn);
  }
}

export { formatMonetaryAmountAsJsx };
//# sourceMappingURL=money.js.map
